import { TEmInvoiceListRequest } from 'redux/reducers/emManagement/types';
import { endpoint } from 'services/endpoint';
import { http, httpQ4US } from 'services/http';
import { TEmManagementApi } from './types';

export const emManagement: TEmManagementApi = {
	getEmManagementList: (payload) =>
		http
			.post(endpoint.emManagement.GET_EM_MANAGEMENT_LIST, payload)
			.then((response) => response.data),
	getEmById: (payload) =>
		http.get(endpoint.emManagement.GET_EM_BY_ID(payload.id)).then((response) => response.data),
	getEmByIdFull: (payload) =>
		http.get(endpoint.emManagement.GET_EM_BY_ID_FULL(payload.id)).then((response) => response.data),
	updateEm: (payload) =>
		http
			.put(endpoint.emManagement.UPDATE_EM(payload.id), payload.data)
			.then((response) => response.data),
	updateEmerchant: (payload) =>
		http
			.put(endpoint.emManagement.UPDATE_EMERCHANT(payload.id), payload.data)
			.then((response) => response),
	unblockEmerchant: (payload) =>
		http
			.put(endpoint.emManagement.UNBLOCK_EMERCHANT(payload.id), {})
			.then((response) => response.data),
	blockEmerchant: (payload) =>
		http
			.put(endpoint.emManagement.BLOCK_EMERCHANT(payload.id), {})
			.then((response) => response.data),
	activateEmerchant: (payload) =>
		http
			.put(endpoint.emManagement.ACTIVATE_EMERCHANT(payload.id))
			.then((response) => response.data),
	duplicateEmerchant: (payload) =>
		http
			.post(endpoint.emManagement.DUPLICATE_EMERCHANT(payload.id))
			.then((response) => response.data),
	activateEuDdp: (payload) =>
		http
			.post(endpoint.emManagement.ACTIVATE_EU_DDP(payload.emId), payload.data)
			.then((response) => response.data),
	getAdditionalServices: (payload) =>
		http
			.post(endpoint.emManagement.GET_ADDITIONAL_SERVICES, payload)
			.then((response) => response.data),
	createAdditionalService: (payload) =>
		http
			.post(endpoint.emManagement.CREATE_ADDITIONAL_SERVICE, payload)
			.then((response) => response.data),
	updateAdditionalService: (payload) =>
		http
			.put(endpoint.emManagement.UPDATE_ADDITIONAL_SERVICE(payload.id), payload.data)
			.then((response) => response.data),
	getEmAdditionalServices: (emId) =>
		http
			.get(endpoint.emManagement.GET_EM_ADDITIONAL_SERVICES(emId))
			.then((response) => response.data),
	createEmAdditionalService: (payload) =>
		http
			.post(endpoint.emManagement.CREATE_EM_ADDITIONAL_SERVICE, payload)
			.then((response) => response.data),
	updateEmAdditionalService: (payload) =>
		http
			.put(endpoint.emManagement.UPDATE_EM_ADDITIONAL_SERVICE(payload.id), payload.data)
			.then((response) => response.data),
	emAdditionalServiceInvoice: (id) =>
		http
			.post(endpoint.emManagement.EM_ADDITIONAL_SERVICE_INVOICE(id))
			.then((response) => response.data),
	emAdditionalServiceCancel: (payload) =>
		http
			.put(endpoint.emManagement.EM_ADDITIONAL_SERVICE_CANCEL(payload.id))
			.then((response) => response.data),
	emInvoicePdf: (payload) =>
		httpQ4US
			.get(endpoint.emManagement.EM_INVOICE_PDF(payload.emId, payload.invoiceId), {
				responseType: 'blob',
				headers: {
					'Content-Type': 'application/pdf',
				},
			})
			.then((response) => response.data),
	getSpecialRegistrations: (payload) =>
		http
			.post(endpoint.emManagement.GET_SPECIAL_REGISTRATIONS(payload.emId), payload)
			.then((response) => response.data),
	addSpecialRegistration: (payload) =>
		http
			.post(endpoint.emManagement.ADD_SPECIAL_REGISTRATION(payload.emId), payload.data)
			.then((response) => response.data),
	updateSpecialRegistration: (payload) =>
		http
			.put(endpoint.emManagement.UPDATE_SPECIAL_REGISTRATION(payload.emId), payload.data)
			.then((response) => response.data),
	addScheduleTermination: (payload) =>
		http
			.post(endpoint.emManagement.ADD_SCHEDULE_TERMINATION(payload.emId), payload.data)
			.then((response) => response.data),
	deleteScheduleTermination: (payload) =>
		http
			.delete(endpoint.emManagement.DELETE_SCHEDULE_TERMINATION(payload.id))
			.then((response) => response.data),
	getEmEnums: (payload) =>
		http
			.get(endpoint.emManagement.EM_ENUMS_BY_TYPE, { params: payload })
			.then((response) => response.data),
	getEnumByName: (payload) =>
		http
			.get(endpoint.emManagement.EM_ENUMS_BY_TYPE, { params: payload })
			.then((response) => response.data),
	getDistinctEnumNames: () =>
		http.get(endpoint.emManagement.DISTINCT_ENUM_NAMES).then((response) => response.data),
	getMonthlyFees: () =>
		http.get(endpoint.monthlyFee.GET_MONTHLY_FEES).then((response) => response.data),
	getFeeClasses: () =>
		http.get(endpoint.monthlyFee.GET_FEE_CLASSES).then((response) => response.data),
	// em comments
	getEmComments: (payload) =>
		http.post(endpoint.emManagement.GET_EM_COMMENTS, payload).then((response) => response.data),
	// em notifications
	getEmNotifications: (payload) =>
		http
			.post(endpoint.emManagement.GET_EM_NOTIFICATIONS, payload)
			.then((response) => response.data),
	getEmCommentById: (payload) =>
		http.get(endpoint.emManagement.GET_EM_COMMENT(payload.id)).then((response) => response.data),
	createEmComment: (payload) =>
		http
			.post(endpoint.emManagement.CREATE_EM_COMMENT, payload.data)
			.then((response) => response.data),
	updateEmComment: (payload) =>
		http
			.put(endpoint.emManagement.UPDATE_EM_COMMENT(payload.id), payload.data)
			.then((response) => response.data),
	registerNominatedPersonAccount: (payload) =>
		httpQ4US
			.post(endpoint.emManagement.REGISTER_NOMINATED_PERSON_ACCOUNT, payload)
			.then((response) => response.data),
	// em sites
	getEmSitesList: (payload) =>
		http
			.get(endpoint.emManagement.GET_EM_SITES_LIST(payload.emId))
			.then((response) => response.data),
	createEmSite: (payload) =>
		http.post(endpoint.emManagement.CREATE_EM_SITE, payload).then((response) => response.data),
	updateEmSite: (payload) =>
		http
			.put(endpoint.emManagement.UPDATE_EM_SITE(payload.id), payload)
			.then((response) => response.data),
	deleteEmSite: (payload) =>
		http
			.delete(endpoint.emManagement.DELETE_EM_SITE(payload.id), {
				params: { emId: payload.emId },
			})
			.then((response) => response.data),
	// dashboard users subscriptions
	getDashboardUsersSubscriptions: (payload) =>
		http
			.get(endpoint.emManagement.GET_DASHBOARD_USERS_SUBSCRIPTIONS(payload.emId), {
				params: { email: payload.email },
			})
			.then((response) => response.data),
	updateDashboardUsersSubscriptions: (payload) =>
		http
			.put(endpoint.emManagement.UPDATE_DASHBOARD_USERS_SUBSCRIPTIONS(payload.emId), payload.data)
			.then((response) => response.data),
	// em invoice list
	getEmInvoiceList: (payload: TEmInvoiceListRequest) =>
		httpQ4US
			.post(endpoint.emManagement.GET_EM_INVOICE_LIST, {
				tableName: 'invoice_list_info',
				orderBy: ['timestamp desc'],
				filter: [
					{
						name: 'em_id',
						value: String(payload.emId),
					},
				],
				page: payload.page,
			})
			.then((response) => response.data),
	// em payment methods
	getEmPaymentMethods: (payload) =>
		http
			.get(endpoint.emManagement.GET_EM_PAYMENT_METHODS(payload.emId))
			.then((response) => response.data),
};
